/* Preserve the specification table on desktop; label each value for mobile. */
(() => {
  const root = document.querySelector('#MainContent[data-template^="product"]');
  if (!root) return;

  // Reflect the native radio immediately; Shopify still resolves every variant change.
  root.addEventListener('change', event => {
    if (!(event.target instanceof HTMLInputElement) || event.target.type !== 'radio' || !event.target.checked) return;
    const fieldset = event.target.closest('.mv-option--material');
    const summary = fieldset?.querySelector('[data-mv-material-selection]');
    const template = summary?.dataset.selectedTemplate;
    if (summary && template) summary.textContent = template.replace('__MERVAUX_VALUE__', event.target.value);
  });

  const annotateTables = () => {
    root.querySelectorAll('.details-content table:not([data-mv-specifications])').forEach(table => {
      const headers = Array.from(table.tHead?.rows[0]?.cells || []);
      const rows = Array.from(table.tBodies).flatMap(body => Array.from(body.rows));
      if (headers.length < 3 || !rows.length || headers.some(cell => cell.colSpan !== 1) ||
          rows.some(row => row.cells.length !== headers.length || Array.from(row.cells).some(cell => cell.colSpan !== 1 || cell.rowSpan !== 1))) return;
      table.dataset.mvSpecifications = '';
      table.setAttribute('role', 'table');
      table.tHead.setAttribute('role', 'rowgroup');
      table.tHead.rows[0].setAttribute('role', 'row');
      headers.forEach(cell => { cell.scope = 'col'; cell.setAttribute('role', 'columnheader'); });
      Array.from(table.tBodies).forEach(body => body.setAttribute('role', 'rowgroup'));
      rows.forEach(row => {
        row.setAttribute('role', 'row');
        Array.from(row.cells).forEach((cell, index) => {
          const label = document.createElement('span');
          label.className = 'mv-spec-label';
          label.setAttribute('aria-hidden', 'true');
          label.textContent = headers[index].textContent.trim();
          const value = document.createElement('div');
          value.className = 'mv-spec-value';
          while (cell.firstChild) value.append(cell.firstChild);
          cell.append(label, value);
          cell.setAttribute('role', 'cell');
        });
      });
    });
  };
  annotateTables();
  new MutationObserver(annotateTables).observe(root, {childList: true, subtree: true});
})();

